import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  // Send email using emailjs
  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs.init('2M14dLmoA057sBkV8');

    const templateParams = {
      from_name: formData.name,
      subject: formData.subject,
      message: formData.message,
      email: formData.email,
      reply_to: "debugger.developers@gmail.com",
    };

    emailjs
      .send(
        'service_byxrhtf',
        'template_vnwlbdl',
        templateParams
      )
      .then(
        (response) => {
          alert("Thank you for reaching out! We will get back to you shortly.");
          setIsLoading(false);
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          alert("FAILED... " + JSON.stringify(error));
          setIsLoading(false);
        }
      );
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      {/* Spinner Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-[var(--bg-color)] bg-opacity-75 z-50 flex items-center justify-center">
          <div className="w-12 h-12 border-4 border-[var(--primary-color)] border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <main
        className="min-h-screen"
        style={{
          backgroundColor: "var(--bg-color)",
          color: "var(--text-color)",
        }}
      >
        {/* Hero */}
        <section className="pt-20 pb-12" style={{ background: "var(--gradient-soft)" }}>
          <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight" style={{ color: "var(--text-color)" }}>
              Let's <span className="ce-serif italic" style={{ color: "var(--accent-color)" }}>talk.</span>
            </h1>
            <p className="mt-4 text-lg max-w-xl mx-auto" style={{ color: "var(--muted-color)" }}>
              Questions about CoursEngage, your campus rollout, or pricing for a department? We'd love to hear from you.
            </p>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16">
          <div className="max-w-6xl mx-auto px-5 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-6">
              {/* Left Column: Contact Form */}
              <div
                className="rounded-2xl p-8 sm:p-10"
                style={{ backgroundColor: "var(--card-bg)", border: "1px solid var(--border-color)", boxShadow: "var(--shadow-sm)" }}
              >
                <h2 className="text-2xl font-semibold mb-6" style={{ color: "var(--text-color)" }}>
                  Send us a message
                </h2>

                <form onSubmit={sendEmail} className="space-y-6">
                  {/* Name */}
                  <div>
                    <label
                      htmlFor="name"
                      className="block mb-1 font-medium text-[var(--text-color)]"
                    >
                      Full name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Full name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-[var(--card-hover-bg)] rounded bg-[var(--card-bg)] text-[var(--text-color)] placeholder:text-[var(--muted-color)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-1 font-medium text-[var(--text-color)]"
                    >
                      Email address
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      pattern="[^ @]*@[^ @]*"
                      placeholder="Email address"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-[var(--card-hover-bg)] rounded bg-[var(--card-bg)] text-[var(--text-color)] placeholder:text-[var(--muted-color)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                    />
                  </div>

                  {/* Subject */}
                  <div>
                    <label
                      htmlFor="subject"
                      className="block mb-1 font-medium text-[var(--text-color)]"
                    >
                      Subject
                    </label>
                    <input
                      type="text"
                      name="subject"
                      id="subject"
                      placeholder="Subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-[var(--card-hover-bg)] rounded bg-[var(--card-bg)] text-[var(--text-color)] placeholder:text-[var(--muted-color)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                    />
                  </div>

                  {/* Message */}
                  <div>
                    <label
                      htmlFor="message"
                      className="block mb-1 font-medium text-[var(--text-color)]"
                    >
                      Tell us about the project
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Leave a comment here"
                      required
                      style={{ height: "160px" }}
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-[var(--card-hover-bg)] rounded bg-[var(--card-bg)] text-[var(--text-color)] placeholder:text-[var(--muted-color)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="ce-btn ce-btn-primary text-base px-6 py-3">
                    Send message
                  </button>
                </form>
              </div>

              {/* Right Column: Contact Info */}
              <div className="flex flex-col gap-5">
                <div className="rounded-2xl p-8" style={{ backgroundColor: "var(--alt-bg)", border: "1px solid var(--border-color)" }}>
                  <div className="text-xs uppercase tracking-[0.14em] font-semibold mb-3" style={{ color: "var(--muted-color)" }}>
                    Email
                  </div>
                  <a href="mailto:info@coursengage.com" className="text-lg font-medium" style={{ color: "var(--text-color)" }}>
                    info@coursengage.com
                  </a>
                  <p className="mt-2 text-sm" style={{ color: "var(--muted-color)" }}>
                    We reply within one business day.
                  </p>
                </div>
                <div className="rounded-2xl p-8" style={{ backgroundColor: "var(--card-bg)", border: "1px solid var(--border-color)" }}>
                  <div className="text-xs uppercase tracking-[0.14em] font-semibold mb-3" style={{ color: "var(--muted-color)" }}>
                    Office
                  </div>
                  <div className="text-base font-medium" style={{ color: "var(--text-color)" }}>Lincoln, Nebraska</div>
                  <p className="mt-1 text-sm" style={{ color: "var(--muted-color)" }}>
                    Lincoln, NE 68508 · United States
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Contact;
